// Stub module that replaces Dummy repo/response files in production/staging builds.
// This prevents dummy test data from being bundled into the production JavaScript.
// The actual Dummy repos are only used in development (see *RepoManager.res files).
module.exports = {};
